'use strict';

var NewCalendarDirective = function NewCalendarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calendar-toolbar.html'),
    controller: 'NewCalendarToolbarController',
    scope: {
      visible: '='
    }
  };
};
NewCalendarDirective.$inject = ['$rootScope'];
module.exports = NewCalendarDirective;